import { useState } from 'react'

import { styled } from 'styled-components'

import { useOnChangeEffect } from 'peach/hooks'

const Wrapper = styled.div`
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 3px;
  background-color: ${(p) => p.theme.background};
  padding: 2px;
  line-height: 1;
`

const Label = styled.span`
  display: inline-block;
  padding: 2px 8px;
  line-height: 1;
  color: ${(p) => p.theme.mutedText};
  font-size: 12px;
`

const Input = styled.input`
  border: 1px solid transparent;
  border-radius: 3px;
  background-color: ${(p) => p.theme.background};
  width: 60px;
  width: ${(p) => p.width};
  text-align: center;
  color: ${(p) => p.theme.text};

  &:disabled {
    border-color: ${(p) => p.theme.border};
    background-color: ${(p) => p.theme.offset};
    color: #888;
  }

  &:focus {
    border-color: ${(p) => p.theme.highlight};
    box-shadow: none;
  }
`

const Button = styled.button`
  border: none;
  border-radius: 3px;
  background-color: transparent;
  cursor: default;
  padding: 4px 8px;
  line-height: 1;
  color: ${(p) => p.theme.mutedText};

  &:disabled {
    color: ${(p) => p.theme.disabledText};
  }

  &:not(:disabled):hover {
    background-color: ${(p) => p.theme.hover};
    cursor: pointer;
    color: ${(p) => p.theme.text};
  }
`

const Spacer = styled.span`
  display: inline-block;
  width: 4px;
`

const PaginationInputControl = (props) => {
  const {
    caption,
    totalPages,
    page,
    onPageChange,
    onRefresh,
    loading,
    disabled,
    showSkip,
  } = props

  const passedValue = _.isFinite(page) ? `${page}` : ''

  const [focused, setFocused] = useState(false)

  const [localPage, setLocalPage] = useState(passedValue)

  const value = focused ? localPage : passedValue

  const handleChange = (str) => {
    const num = parseInt(str)

    if (str === '') {
      setLocalPage('')
    } else if (_.isFinite(num) && `${num}` === str) {
      setLocalPage(str)
    }
  }

  useOnChangeEffect(() => {
    if (!focused) setLocalPage(passedValue)
  }, [passedValue])

  const handleBlur = () => {
    const num = parseInt(localPage)

    const newValue = Math.max(Math.min(num, totalPages), 1)

    setFocused(false)
    setLocalPage(`${newValue}`)

    _.defer(() => onPageChange(newValue))
  }

  const disablePrev = disabled || page <= 1

  const disableNext = disabled || page >= totalPages

  return (
    <Wrapper>
      <Button disabled={disablePrev} onClick={() => onPageChange(1)}>
        ❮❮
      </Button>

      <Spacer />

      <Button disabled={disablePrev} onClick={() => onPageChange(page - 1)}>
        ❮
      </Button>

      <Spacer />

      <Input
        value={value}
        onChange={(evt) => handleChange(evt.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
      />

      <Spacer />

      <Button disabled={disableNext} onClick={() => onPageChange(page + 1)}>
        ❯
      </Button>

      <Spacer />

      {showSkip && (
        <Button disabled={disableNext} onClick={() => onPageChange(totalPages)}>
          ❯❯
        </Button>
      )}

      <Spacer />

      {onRefresh && (
        <>
          <Button disabled={loading} onClick={onRefresh}>
            ↻
          </Button>
          <Spacer />
        </>
      )}

      <Spacer />

      <Label>{caption}</Label>
    </Wrapper>
  )
}

export default PaginationInputControl
